import React from 'react'
import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'
import PlusTextTag from '../../../privateDeals/PrivateDealTag/PlusTextTag'
import Timeline, {TimelineItemBody, TimelineItemHeader} from '../Timeline'

export const MemberPlusTimeline = () => (
  <Timeline>
    <TimelineItemHeader>
      <FormattedMessageWrapper
        id="membership.howItWorks.signIn"
        defaultMessage="1. Sign in"
      />
    </TimelineItemHeader>
    <TimelineItemBody>
      <FormattedMessageWrapper
        id="membership.howItWorks.signInToUnlockPlusDeals"
        defaultMessage="Sign in to your account to unlock FindHotel Plus deals."
      />
    </TimelineItemBody>

    <TimelineItemHeader>
      <FormattedMessageWrapper
        id="membership.howItWorks.startSaving"
        defaultMessage="2. Start Saving"
      />
    </TimelineItemHeader>
    <TimelineItemBody>
      <FormattedMessageWrapper
        id="membership.howItWorks.startSavingMessage"
        defaultMessage="Look for the {plusDeal} to book your stay at the best possible rate."
        values={{plusDeal: <PlusTextTag>Deal</PlusTextTag>}}
      />
    </TimelineItemBody>

    <TimelineItemHeader>
      <FormattedMessageWrapper
        id="membership.howItWorks.keepSaving"
        defaultMessage="3. Keep saving"
      />
    </TimelineItemHeader>
    <TimelineItemBody isLastStep>
      <FormattedMessageWrapper
        id="membership.howItWorks.freeAccess"
        defaultMessage="Your Plus Member status never expires, so you’ll always have access to the best accomodation deals – only available here on FindHotel."
      />
    </TimelineItemBody>
  </Timeline>
)
